import * as React from "react"; 
import { BuildPartGW } from "./BuildPartGW"
import { BDKalkCore } from "./BDKalkCore"
import { ChoiseControlBuildPartQR } from "./ChoiseControlBuildPartQR"
 
///////////////   BuildPartQRItem  ////////////////

export interface BuildPartQRItemVm {
    key: string,
    index: number,
    core: BDKalkCore,
    buildPart: BuildPartGW
}

export interface BuildPartItemQRStates {
    mouseState: string,
    inputActive: boolean
}

export class BuildPartQRItem extends React.Component<BuildPartQRItemVm,BuildPartItemQRStates> {

    state: BuildPartItemQRStates = {
        mouseState: "out",
        inputActive: false
    }

    GetInputActive() {
        var coreItem = this.props.core.GetInputItemBPQR()
        if (coreItem == null) {
            return false
        }
        else {
            if (coreItem.props.buildPart.GetId() == this.props.buildPart.GetId()) {
                return true
            }
            else {
                return false
            }
        }
    }

    constructor(props: BuildPartQRItemVm) {
        super(props)
        this.m_clickedArea = "none"
    }

    // SetLocation is used internally by sub controls to specify where the item has been clicked
    SetLocation(location: string) {
        this.m_clickedArea = location
    }

    // Mouse up handler
    onMouseUp() {
        this.setState({ mouseState: "hover" })
        this.m_choiseCtrl.setState({ hovering: true })
    }

    // Mouse out handler
    onMouseOut() {
        if (this.GetInputActive() == false) {
            this.setState({ mouseState: "out" })
            this.m_choiseCtrl.setState({ hovering: false })
            this.m_choiseCtrl.setState({ plusPressed: false })
            this.m_choiseCtrl.setState({ minusPressed: false })
            this.m_choiseCtrl.setState({ crossPressed: false })
        }
        else {
            this.setState({ mouseState: "out" })
        }
    }

    // Sets the amount to a new value and forces the affected displays to redraw instantly
    SetAmount(newAmount: number) {
        this.props.buildPart.SetAmount(newAmount)
        this.forceUpdate()
        this.props.core.RedrawTotalSum()
    }

    // Mouse over handler
    onMouseOver() {
        this.setState({ mouseState: "hover" })
        this.m_choiseCtrl.setState({ hovering: true })
    }

    // Mouse down (pressed) handler
    onMouseDown() {
        this.setState({ mouseState: "hover" })
    }

    // Mouse click handler
    onClick() {
        const area = this.m_clickedArea
        this.m_clickedArea = "none"
        this.props.core.HandleBuildPartQRItemClick(this, area)
    }

    // 
    public ConnectQRChoise(choiseCtrl: ChoiseControlBuildPartQR) {
        this.m_choiseCtrl = choiseCtrl
        this.m_clickedArea = "none"
    }

    GetAsTwoDecimalString(value: number) {
        var result = value.toString()
        var decimalsShown = 0
        var passedComma = false

        // Counting the decimals of the total sum string
        for (var i = 0; i < result.length; i++) {
            if (passedComma == true) {
                decimalsShown++
            }

            // Ensuring there is no more than two decimals shown
            if (decimalsShown > 2) {
                result = result.slice(0, i)
                break
            }

            if (result[i] == '.') {
                passedComma = true
            }
        }

        // Ensuring there is allways two decimals shown on the total sum 
        if (decimalsShown == 0) {
            result += ".00"
        }

        if (decimalsShown == 1) {
            result += "0"
        }

        return result
    }

    public render() {
        var elements: Array<JSX.Element> = new Array<JSX.Element>()
        var arts = this.props.buildPart.GetArticles()

        var radioPos = this.props.core.GetPriceRadio()
        var flags = this.props.core.GetPriceFlags()

        const bgFile = "url(images/selectionLoadButtons.png)"
        var loadOffsetX = "-0px"
        var loadOffsetY = "-0px"
        var mergeOffsetX = "-33px"
        var mergeOffsetY = "-0px"
        var delOffsetX = "-128px"
        var delOffsetY = "-0px"
        var hoverstate = "out"
        const leftMargin = "20px"
        const left = "70px"
        const midLeft = "67px"
        const midRight = "55px"
        const rightMargin = "0px"

        const itemsHeight = 30
        const itemHeight = 17
        const artsTitleHeight = 22
        const titleHeight = 42
        const buildEditAreaHeight = 167
        const buttonsLeftMargin = "35px"
        const buttonsCenterMargin = "10px"
        const buttonsAreaHeight = "38px"
        const itemFontSize = "16px"
        const itemYAdjustment = "1px"
        const separationMargin = 22

        var showingExtended: boolean = ((this.props.core.GetSelectionID() == this.props.buildPart.GetId()) && (this.props.core.GetApp().state.ExtInfoUp == true)) ? true : false
        var keyIndex = 0

        // Contents
        for (var i = 0; (i < arts.length) && (showingExtended == true); i++) {
            const keyStr = (keyIndex++).toString()
            if (arts[i].GetAmount() != 0) {
                elements.push(<div key={keyStr} style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                    <div style={{ width: "35px" }}></div>
                    <div style={{ color: "grey", width: "35px" }}>{arts[i].GetAmount()}</div>
                    <div style={{ color: "grey", width: "45px" }}>{arts[i].GetUnit()}</div>
                    <div style={{ color: "grey", width: "350px" }}>{arts[i].GetDescription()}</div>
                    <div style={{ color: "grey", width: "120px", textAlign: "right" }}>{arts[i].GetUnitPriceString(radioPos, flags, false, null)}</div>
                    <div style={{ color: "grey", width: "140px", textAlign: "right" }}>{arts[i].GetSumString(radioPos, flags)}</div>
                </div>)
            }
        }

        const BPAmount = (showingExtended == true) ? (elements.length) : 0
        var SubBPAmount = 0

        if (this.props.buildPart.GetIncludedBuildParts() != null) {
            SubBPAmount = (showingExtended == true) ? (this.props.buildPart.GetIncludedBuildParts().length) : 0
            
            // Adding the title area:
            if (SubBPAmount > 0) {
                const keyStr0 = (keyIndex++).toString()
                {/* separation margin */ }
                elements.push(<div key={keyStr0} style={{ width: "100%", height: (separationMargin.toString() + "px") }}>

                </div>)

                const keyStr1 = (keyIndex++).toString()

                {/* title area */ }
                elements.push(<div key={keyStr1} style={{ width: "100%", height: (titleHeight.toString() + "px") }}>
                    <div style={{ position: "relative", left: buttonsLeftMargin, top: "10px", fontSize: "18px", color: "gray" }}>
                        Inkluderte Byggdeler:
                    </div>
                </div>)

                const keyStr2 = (keyIndex++).toString()

                {/* build parts title area */ }
                elements.push(<div key={keyStr2} style={{ width: "100%", height: (artsTitleHeight.toString() + "px"), display: "flex", flexDirection: "row", fontSize: "18px" }}>
                    <div style={{ width: "35px" }} >
                    </div>

                    <div style={{ width: "35px", color: "gray", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                        Antall
                    </div>

                    <div style={{ width: "45px", color: "gray", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                    </div>

                    <div style={{ width: "350px", color: "gray", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                        Byggdel
                    </div>

                    <div style={{ width: "120px", color: "gray", textAlign: "right", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                        Pris
                    </div>

                    <div style={{ width: "140px", color: "gray", textAlign: "right", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                        Summa
                    </div>
                </div>)
            }

            var parts = this.props.buildPart.GetIncludedBuildParts()
            for (var i = 0; (i < parts.length) && (showingExtended == true); i++) {
                const keyStr = (keyIndex++).toString()
                if (parts[i].amount != 0) {
                    elements.push(<div key={keyStr} style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                        <div style={{ width: "35px" }}></div>
                        <div style={{ color: "grey", width: "35px" }}>{parts[i].amount}</div>
                        <div style={{ color: "grey", width: "45px" }}></div>
                        <div style={{ color: "grey", width: "350px" }}>{parts[i].ref.GetTitle()}</div>
                        <div style={{ color: "grey", width: "120px", textAlign: "right" }}>{parts[i].ref.GetPriceString(radioPos, flags)}</div>
                        <div style={{ color: "grey", width: "140px", textAlign: "right" }}>{ this.GetAsTwoDecimalString(parts[i].ref.GetPrice(radioPos, flags) * parts[i].amount) }</div>
                    </div>)
                }
            }
        }
        
        var extAreaHeight = 0
        
        if (showingExtended == true) {
            // Article content section
            extAreaHeight += artsTitleHeight
            extAreaHeight += titleHeight
            extAreaHeight += (BPAmount * itemHeight)

            // Included buildparts section
            extAreaHeight += (SubBPAmount * itemHeight)
            extAreaHeight += (SubBPAmount != 0) ? titleHeight : 0 // Adding space for the title above included buildparts
            extAreaHeight += (SubBPAmount != 0) ? artsTitleHeight : 0 // Adding space for the row of titles above included buildparts
            extAreaHeight += (SubBPAmount != 0) ? separationMargin : 0 // Adding space for separation margin
            extAreaHeight += 10 // Bottom margin
        }

        var totHeight = (itemsHeight + extAreaHeight).toString() + "px"
        var topHeight = itemsHeight.toString() + "px"

        // Hovering or selecting the item will cause it to render with some visual differences, and hoverstyle (below) holds the final set of characteristics to be rendered
        var hoverstyle = { width: '100%', height: totHeight, borderTop: '1px solid white', borderBottom: '1px solid white' }
        var hoverstyle_hover = { width: '100%', height: totHeight, backgroundColor: '#EAf3FF', borderTop: '1px solid #EAf3FF', borderBottom: '1px solid #EAf3FF' }
        var hoverstyle_selected = { width: '100%', height: totHeight, backgroundColor: '#EAf3FF', borderTop: '1px solid #CAd3dF', borderBottom: '1px solid #CAd3dF' }
        var favStr = ""
        var extInfoArrowOffset = 7
        var extInfoArrowShow = false // If or not the ext info dropdown arrow should be displayed

        // When the selected article is being hovered, the arrow to collapse/expand the extended info will light up a bit
        if (this.props.core.GetSelectionSetManager().GetHoveredBuildPartIndex() == this.props.index) {
            hoverstyle = hoverstyle_hover
            extInfoArrowOffset += 68
        }

        // If ext info is shown, the arrow will point upward as to show it can be hidden by clicking the article again
        if (this.props.core.GetApp().state.ExtInfoUp == true) {
            extInfoArrowOffset += 34
        }

        // Only the selected article can have an arrow to hide/show the extended info
        if (this.isSelected()) {
            this.props.core.ConnectSelectedBuildPartQRItem(this)
            hoverstyle = hoverstyle_selected
            extInfoArrowShow = true
        }

        if (this.props.core.GetSelectionSetManager().GetHoveredBuildPartIndex() == this.props.index) {
            hoverstate = "over"
        }

        var extensionArea = <div></div>

        const bgPosition = "0px -" + extInfoArrowOffset.toString() + "px"
        var isVisible = (this.isSelected()) ? "visible" : "hidden"

        if (showingExtended == true) {
            extensionArea = <div onMouseEnter={e => this.onMouseEnterExt()} style={{ width: "100%", height: (extAreaHeight.toString() + "px") }}>
                {/* title area */}
                <div style={{ width: "100%", height: (titleHeight.toString() + "px") }}>
                    <div style={{ position: "relative", left: buttonsLeftMargin, top: "10px", fontSize: "18px", color: "gray" }}>
                        Innhold:
                    </div>
                </div>

                {/* articles title area */}
                <div style={{ width: "100%", height: (artsTitleHeight.toString() + "px"), display: "flex", flexDirection: "row", fontSize: "18px" }}>
                    <div style={{ width: "35px" }} >
                    </div>

                    <div style={{ width: "35px", color: "gray", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                        Ant
                    </div>

                    <div style={{ width: "45px", color: "gray", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                        Enh
                    </div>

                    <div style={{ width: "350px", color: "gray", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                        Varetext
                    </div>

                    <div style={{ width: "120px", color: "gray", textAlign: "right", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                        Pris
                    </div>

                    <div style={{ width: "140px", color: "gray", textAlign: "right", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                        Summa
                    </div>
                </div>

                {elements}

                <div style={{ height: "15px" }}>
                </div>
            </div>
        }
        else {
            totHeight = "0px"
        }
        
        if (hoverstate == "over") {
            return <div onMouseEnter={e => this.OnItemEnter(e)} onMouseOut={e => this.onMouseOut()} onClick={this.onClick.bind(this)} style={hoverstyle}>
                <div style={{ display: "flex", flexDirection: "row", width: "100%", height: topHeight }}>
                    <div style={{ width: "145px", display:"flex", flexDirection:"row" }}>
                        <div style={{ width: "5px" }}>
                        </div>

                        {/* Ext Info arrowdown area */}
                        <div style={{ width: "25px", height: "20px", backgroundImage: "url(images/UtvidetInfoLocalArrow.png)", backgroundPosition: bgPosition, visibility: isVisible, position: "relative", top: "4px", left: "0px" }} ></div>

                        <div style={{ width: "5px" }}>
                        </div>

                        <ChoiseControlBuildPartQR core={this.props.core} buildPartQRItem={this} />
                    </div>

                    <div style={{ width: "calc(100% - 180px)", display: "flex", flexDirection: "row" }}>
                        <div style={{ width: "10%", fontSize: itemFontSize, color: "grey", position: "relative", top: itemYAdjustment }}>{""}</div>

                        <div style={{ width: "50%", fontSize: itemFontSize, color: "grey", position: "relative", top: itemYAdjustment }}>{this.props.buildPart.GetTitle()}</div>

                        <div style={{ width: "15%", fontSize: itemFontSize, color: "grey", textAlign: "right", position: "relative", top: itemYAdjustment }}>{this.props.buildPart.GetPriceString(radioPos, flags)}</div>

                        <div style={{ width: "15%", fontSize: itemFontSize, color: "grey", textAlign: "right", position: "relative", top: itemYAdjustment }}>{this.props.buildPart.GetTotalSumString(radioPos, flags)}</div>

                        <div style={{ width: "10%", height: "1px" }}></div>
                    </div>
                </div>
                {extensionArea}
            </div>
        }
        else {

            // Putting together the background image position
            var loadBgPosition = loadOffsetX + " " + loadOffsetY
            var mergeBgPosition = mergeOffsetX + " " + mergeOffsetY
            var delBgPosition = delOffsetX + " " + delOffsetY

            return <div onMouseEnter={e => this.OnItemEnter(e)} onMouseOut={e => this.onMouseOut()} onClick={this.onClick.bind(this)} style={hoverstyle}>
                <div style={{ display: "flex", flexDirection: "row", width: "100%", height: topHeight }}>
                    <div style={{ width: "145px", display: "flex", flexDirection: "row" }}>

                        <div style={{width:"5px"}}>
                        </div>

                        {/* Ext Info arrowdown area */}
                        <div style={{ width: "25px", height: "20px", backgroundImage: "url(images/UtvidetInfoLocalArrow.png)", backgroundPosition: bgPosition, visibility: isVisible, position: "relative", top: "4px", left: "0px" }} ></div>

                        <div style={{ width: "5px" }}>
                        </div>

                        <ChoiseControlBuildPartQR core={this.props.core} buildPartQRItem={this} />
                    </div>

                    <div style={{ width: "calc(100% - 180px)", display: "flex", flexDirection: "row" }}>
                        <div style={{ width: "10%", fontSize: itemFontSize, color: "grey", position: "relative", top: itemYAdjustment }}>{""}</div>

                        <div style={{ width: "50%", fontSize: itemFontSize, color: "grey", position: "relative", top: itemYAdjustment }}>{this.props.buildPart.GetTitle()}</div>

                        <div style={{ width: "15%", fontSize: itemFontSize, color: "grey", textAlign: "right", position: "relative", top: itemYAdjustment }}>{this.props.buildPart.GetPriceString(radioPos, flags)}</div>

                        <div style={{ width: "15%", fontSize: itemFontSize, color: "grey", textAlign: "right", position: "relative", top: itemYAdjustment }}>{this.props.buildPart.GetTotalSumString(radioPos, flags)}</div>

                        <div style={{ width: "10%", height: "1px" }}></div>
                    </div>
                </div>
                {extensionArea}
            </div>
        }
    }
    
    // Returns true if the article held by this item is the one currently selected within the application
    isSelected() {
        return this.props.core.GetSelectionID() == this.props.buildPart.GetId()
    }

    onMouseEnterExt() {
        // this.setState({ mouseState: "out" })
    }
    
    OnItemEnter(e: React.MouseEvent<HTMLDivElement>) {
        this.props.core.GetSelectionSetManager().SetHoveredBuildPartIndex(this.props.index)
        this.setState({ mouseState: "hover" })
        this.m_choiseCtrl.setState({ hovering: true })
    }

    GetIsHovered() {
        if (this.props.core.GetSelectionSetManager().GetHoveredBuildPartIndex() == this.props.index) {
            return true
        }
        else {
            return false
        }
    }
    
    m_choiseCtrl: ChoiseControlBuildPartQR
    private m_clickedArea: string // This is set by the various controls being clicked, then reset to "none" in onClick for the entire item, after the click has been handled
}



// WEBPACK FOOTER //
// ./client/view/BuildPartQRItem.tsx